import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { topics } from '@/mocks/topics';
import type { Article, Category, Topic } from '@/types';

export const allArticles = articles;
export const allCategories = categories;
export const allTopics = topics;

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}

export function getTopicBySlug(slug: string): Topic | undefined {
  return topics.find((t) => t.slug === slug);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getArticlesByIds(ids: string[]): Article[] {
  return ids
    .map((id) => articles.find((a) => a.id === id))
    .filter((a): a is Article => Boolean(a));
}

export function getRelated(article: Article, n = 4): Article[] {
  const same = articles.filter((a) => a.category === article.category && a.id !== article.id);
  if (same.length >= n) return same.slice(0, n);
  const others = articles.filter((a) => a.category !== article.category && a.id !== article.id);
  return [...same, ...others].slice(0, n);
}

export function getHotArticles(n = 6): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, n);
}

export function getLatestArticles(n?: number): Article[] {
  const sorted = [...articles].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );
  return typeof n === 'number' ? sorted.slice(0, n) : sorted;
}

export function searchArticles(keyword: string): Article[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return articles.filter((a) => {
    const haystack = [a.title, a.summary, a.categoryName, a.author, ...a.tags].join(' ').toLowerCase();
    return haystack.includes(q);
  });
}

export function getHotKeywords(): string[] {
  return ['暑期档', '新专辑', '红毯', '露营', '科幻', '水光肌', '联名', '回归'];
}

export function formatViews(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return String(n);
}

export function formatDate(date: string): string {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}